import { render, staticRenderFns } from "./PingConfig.vue?vue&type=template&id=b8ba1586&scoped=true"
import script from "./PingConfig.vue?vue&type=script&lang=ts"
export * from "./PingConfig.vue?vue&type=script&lang=ts"
import style0 from "./PingConfig.vue?vue&type=style&index=0&id=b8ba1586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ba1586",
  null
  
)

export default component.exports